import React from 'react';
import Modal from './Modal';
import { BACKGROUNDS } from '../services/desktopService';
import './BackgroundSelector.css';

function BackgroundSelector({ currentBackground, onSelect, onClose }) {
  return (
    <Modal isOpen={true} onClose={onClose} title="Choose Desktop Background">
      <div className="background-selector-grid">
        {BACKGROUNDS.map(bg => (
          <div
            key={bg.id}
            className={`background-preview ${currentBackground === bg.id ? 'selected' : ''}`}
            onClick={() => onSelect(bg.id)}
          >
            <div
              className="background-preview-swatch"
              style={{ background: bg.preview }}
            ></div>
            <div className="background-preview-name">{bg.name}</div>
          </div>
        ))}
      </div>
    </Modal>
  );
}

export default BackgroundSelector;
